export default __webpack_public_path__ + "static/media/marker-10.f859ef6b.jpg";